import { Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';
import { FC } from 'react';

type Props = {
  description: string;
};

export const EmptyStateText = {
  default:
    'Recordings from your calendar meetings or manually created ones will appear here.',
  personalCalls: 'Your personal call recordings will be shown here.',
  filter: 'No recordings match your current filter criteria.',
} as const;

export const EmptyState: FC<Props> = ({ description }) => {
  return (
    <div className="flex-grow-1 self-center flex flex-col gap-y-4 items-center justify-center w-88">
      <div className="flex items-center justify-center w-12 h-12 border border-gray-200 rounded-lg shadow-xs">
        <Icon glyph={IconMap.HeadPhones02} />
      </div>
      <div className="flex flex-col justify-center items-center gap-y-1 text-center">
        <h3 className="text-gray-900 text-md font-semibold">
          No call recordings found
        </h3>
        <p className="text-gray-600 text-sm">{description}</p>
      </div>
    </div>
  );
};
